import type { PropsWithChildren } from '@shared/utils';
import { createContext, useMemo, useState } from 'react';

import { TaskOverdueNoticeModal } from '../../components';

export enum QSetReviewSubtaskDetailsModalAction {
  OVERDUE_NOTICE = 'OVERDUE_NOTICE',
}

type ActionType = keyof typeof QSetReviewSubtaskDetailsModalAction;

interface QSetReviewModalContext {
  setAction: (action: ActionType | null) => void;
}

export const QSetReviewModalContext = createContext<QSetReviewModalContext | null>(null);

export default function QSetReviewModalProvider(props: Readonly<PropsWithChildren>) {
  const { children } = props;

  const [action, setAction] = useState<ActionType | null>(null);

  const handleCloseModal = () => {
    setAction(null);
  };

  const handleSetAction = (action: ActionType | null) => {
    setAction(action);
  };

  const contextValue = useMemo(
    () => ({
      setAction: handleSetAction,
    }),
    [],
  );

  return (
    <QSetReviewModalContext.Provider value={contextValue}>
      {children}
      <TaskOverdueNoticeModal
        open={action === QSetReviewSubtaskDetailsModalAction.OVERDUE_NOTICE}
        onClose={handleCloseModal}
      />
    </QSetReviewModalContext.Provider>
  );
}
